import { useState, useEffect } from "react";
import HelpHero from "./HelpHero";
import Categories from "./Categories";
import FAQAccordion from "./FAQAccordion";
import Footer from "../landing/Footer";
import GuestNavbar from "../navigations/GuestNavbar";

export default function HelpCenterLayout() {
  const [selectedCategory, setSelectedCategory] = useState("get-started");

  useEffect(() => {
    setSelectedCategory("get-started");
  }, []);

  return (
    <>
    <GuestNavbar/>
    <div className="pt-14 min-h-screen bg-emerald-50">
      <HelpHero onSearch={(q) => console.log("search:", q)} />

      <div className="px-4 mx-auto max-w-6xl sm:px-6">
        <Categories selected={selectedCategory} onSelect={setSelectedCategory} />

        <div className="p-4 mt-10 rounded-2xl bg-emerald-100/50 sm:p-6">
          <h2 className="text-lg font-extrabold text-center text-gray-900">Frequently Asked Question</h2>
          <p className="mt-1 mb-6 text-xs text-center text-gray-700">
            We've included some frequently asked questions below. Still needs help? <button type="button" className="text-emerald-700 underline">Contact our support</button> options
          </p>
          <FAQAccordion selectedCategory={selectedCategory} />
        </div>
      </div>
      <Footer/>
    </div>
    </>
  );
}


